import PropTypes from 'prop-types';

import ReactMarkdown from 'react-markdown';

import { toHumanReadableDate } from '../../utils/dateUtil';

const PrivacyChangeList = ({ changes }) => <section className="privacy-changes">
  <h3>Oppsummering av endringer</h3>

  <ul className="non-listed privacy-changes-list">
    {changes.map((c, idx) => <li key={`change-${idx}`} className="privacy-changes-item">
      <em className="small">Oppdatert: {toHumanReadableDate(c.created_on)}</em>

      <ReactMarkdown source={c.summary} className="privacy-summary"/>
    </li>)}
  </ul>
</section>;

PrivacyChangeList.propTypes = {
  changes: PropTypes.array.isRequired,
};

export default PrivacyChangeList;
